// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class ChangeTradingPasswordMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_CHANGE_TRADING_PASSWORD_REQUEST, fieldSet);
    }
    getUserId() {
        return this.getFieldValue(FieldsFactory.FIELD_USER_ID);
    }
    setUserId(userId) {
        this.setFieldValue(FieldsFactory.FIELD_USER_ID, userId);
    }
    getPassword() {
        return this.getFieldValue(FieldsFactory.FIELD_PASSWORD);
    }
    setPassword(password) {
        this.setFieldValue(FieldsFactory.FIELD_PASSWORD, password);
    }
    getNewPassword() {
        return this.getFieldValue(FieldsFactory.FIELD_NEWPASSWORD);
    }
    setNewPassword(password) {
        this.setFieldValue(FieldsFactory.FIELD_NEWPASSWORD, password);
    }
}
